// removed by extract-text-webpack-plugin
module.exports = {"Card":"SignupForm__Card__3RAxq","Title":"SignupForm__Title__2z8ka","FormWrapper":"SignupForm__FormWrapper__akNy2","LoginForm":"SignupForm__LoginForm__2DT2m","Inputs":"SignupForm__Inputs__1t4l5","SignupCTA":"SignupForm__SignupCTA__CpAYX","ErrorMessage":"SignupForm__ErrorMessage__ttrP-","CrossLink":"SignupForm__CrossLink__2PhKb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/SignupForm/SignupForm.css
// module id = 170
// module chunks = 0